import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { partnerWorkerService } from 'partner/shared/services';
import { CreatePartnerWorkerClaPayload } from 'partner/shared/services/partner-worker-service.types';

type CreatePartnerWorkerClaParams = {
  partnerWorkerId: string;
  payload: CreatePartnerWorkerClaPayload;
};

export const useCreatePartnerWorkerCla = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ partnerWorkerId, payload }: CreatePartnerWorkerClaParams) => {
    await partnerWorkerService.createPartnerWorkerCla(partnerWorkerId, payload);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.workers());
    },
  });
};
